// routes/_app.credit-exchange.redeem.tsx
import { dynamic } from 'src/utils/ssr'

const getClientModule = () =>
  import('src/clientRoutes/_app.credit-exchange.redeem')

export const handle = { name: 'credit-exchange-redeem' }

export default dynamic(getClientModule, { ssr: false })
